var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoMission = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 20,
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.600098 0H13.6001L20.6001 4V20H7.6001L0.600098 16V0Z",
  fill: "#A4A4A4"
})));
export { SvgNoMission as ReactComponent };
export default __webpack_public_path__ + "assets/196d1489.svg";